import React from "react";
import {ReactDatePickerCustomHeaderProps} from "react-datepicker";
import IconNext from "../../../data/Icons/leon-inmobiliaria-icons-arrow-2-forward.svg";

interface CustomHeaderProps extends ReactDatePickerCustomHeaderProps {
    twoMonth?: boolean;
}

function CustomHeaderThreeMonths({
                          date,
                          decreaseMonth,
                          increaseMonth,
                          twoMonth,
                          monthDate,
                          customHeaderCount
                      }: CustomHeaderProps) {
    const months = [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ];

    return (
        <div className="pb-6 flex content-center items-center w-full justify-center">
            {twoMonth ? (
                customHeaderCount === 0 && (
                    <button
                        type="button"
                        aria-label="Previous Month"
                        className={"mr-auto"}
                        onClick={decreaseMonth}
                    >
                        <IconNext className={"rotate-180 w-6"}/>
                    </button>
                )
            ) : (
                <button
                    type="button"
                    aria-label="Previous Month"
                    className={"mr-auto"}
                    onClick={decreaseMonth}
                >
                    <IconNext className={"rotate-180 w-6"}/>
                </button>
            )}

            <p className={`font-normal leading-0 px-10 md:text-[24px] tracking-normal ${
                twoMonth
                ? customHeaderCount === 0
                    ? "mr-auto"
                    : customHeaderCount === 2
                    ? "ml-auto"
                    : ""
                : ""
            }`}>
                {months[monthDate.getMonth()] + " " + monthDate.getFullYear()}
            </p>
            {twoMonth ? (
                customHeaderCount === 2 && (
                    <button
                        type="button"
                        aria-label="Next Month"
                        className={"ml-auto"}
                        onClick={increaseMonth}
                    >
                        <IconNext className="w-6"/>
                    </button>
                )
            ) : (
                <button
                    aria-label="Next Month"
                    type="button"
                    className={"ml-auto"}
                    onClick={increaseMonth}
                >
                    <IconNext className="w-6"/>
                </button>
            )}
        </div>
    );
}

export default CustomHeaderThreeMonths;
